import { theme } from 'styled-tools';
import 'styled-components';
import styled from './styled.js';
import './chunk-79dadc73.js';
import 'react';
import 'hoist-non-react-statics';
import { a as as } from './as-39ca1b5e.js';
import '@emotion/is-prop-valid';
import 'prop-types';
import './chunk-afcdbe83.js';
import './chunk-1128464e.js';
import Box from './Box.js';
var Label = styled(Box).withConfig({
  displayName: "Label",
  componentId: "sc-1e601m4-0"
})(["display:inline-block;", ";"], theme("Label"));
var Label$1 = as("label")(Label);
export default Label$1;